import { styled } from '../../theming';
import { responsiveProp, ResponsiveProp } from '../../utils/responsiveProp';

export const LogoWrapper = styled.div<{ showLogo?: ResponsiveProp<boolean> }>`
  ${({ showLogo }) => ({
    ...responsiveProp(showLogo, (showLogo) => ({
      display: showLogo ? 'block' : 'none',
    })),
  })}
`;
